// src/components/Navbar.tsx
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navbarRef = useRef<HTMLElement>(null);

  // Add scroll listener for changing navbar style
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu & scroll to top on route change
  useEffect(() => {
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav ref={navbarRef} className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link className="navbar-brand" to="/">
          <span className="logo-icon">🐾</span> Viva Pets
        </Link>

        <div className={`navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
          <ul className="navbar-nav">
            {[
              { to: "/", label: "Home" },
              { to: "/AboutUsPage", label: "About Us" },
              { to: "/pets", label: "Pets" },
              { to: "/testimonials", label: "Testimonials" },
              { to: "/ContactPage", label: "Contact Us" },
              { to: "/AdminPanel", label: "AdminPanel" },
            ].map((item) => (
              <li key={item.to} className="nav-item">
                <Link
                  className={`nav-link ${isActive(item.to) ? 'active' : ''}`}
                  to={item.to}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <button
          className={`navbar-toggler ${isMenuOpen ? 'open' : ''}`}
          type="button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle navigation"
          aria-expanded={isMenuOpen}
        >
          <span className="toggler-bar top-bar"></span>
          <span className="toggler-bar middle-bar"></span>
          <span className="toggler-bar bottom-bar"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
